module.exports = __webpack_public_path__ + "img/motorcheck.cf1f6e59.png";